import script from "./AdminDashBoardView.vue?vue&type=script&setup=true&lang=js"
export * from "./AdminDashBoardView.vue?vue&type=script&setup=true&lang=js"

import "./AdminDashBoardView.vue?vue&type=style&index=0&id=68b42874&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-68b42874"]])

export default __exports__